import Vue from 'vue';
import Router from 'vue-router';
import Meta from 'vue-meta';
import { routes } from '../app';
import { App } from '../app';

Vue.use(Router);
Vue.use(Meta);

Vue.config.ignoredElements = [
    'DeviceData',
    'b-tabs',
    'b-tab',
];

export default new Router({
    mode: 'history',
    component: App,
    routes: routes
});


// WEBPACK FOOTER //
// ./src/router/index.js